var _circle, _mask, _path, _path2, _g, _rect, _circle2, _path3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 132,
    viewBox: "0 0 64 132",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 22,
    r: 9.25,
    stroke: "#50595F",
    strokeWidth: 1.5
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-2-inside-1_1_109",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0908 16.2133V22.5596C31.0908 22.7621 31.2103 22.9501 31.4064 23.054L35.5624 25.554C35.8696 25.7179 36.2689 25.6296 36.4527 25.3562C36.6371 25.0833 36.5378 24.7285 36.23 24.5652L32.3896 22.233V16.2133C32.3896 15.8948 32.0987 15.6364 31.7402 15.6364C31.3817 15.6364 31.0908 15.8948 31.0908 16.2133Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0908 16.2133V22.5596C31.0908 22.7621 31.2103 22.9501 31.4064 23.054L35.5624 25.554C35.8696 25.7179 36.2689 25.6296 36.4527 25.3562C36.6371 25.0833 36.5378 24.7285 36.23 24.5652L32.3896 22.233V16.2133C32.3896 15.8948 32.0987 15.6364 31.7402 15.6364C31.3817 15.6364 31.0908 15.8948 31.0908 16.2133Z",
    fill: "#50595F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4064 23.054L32.1796 21.7686L32.1445 21.7475L32.1084 21.7284L31.4064 23.054ZM35.5624 25.554L34.7892 26.8394L34.8223 26.8593L34.8564 26.8775L35.5624 25.554ZM36.4527 25.3562L35.2099 24.5163L35.2077 24.5195L36.4527 25.3562ZM36.23 24.5652L35.4514 25.8473L35.4886 25.8699L35.5271 25.8903L36.23 24.5652ZM32.3896 22.233H30.8896V23.077L31.611 23.5151L32.3896 22.233ZM29.5908 16.2133V22.5596H32.5908V16.2133H29.5908ZM29.5908 22.5596C29.5908 23.3761 30.0713 24.0443 30.7045 24.3796L32.1084 21.7284C32.3493 21.856 32.5908 22.148 32.5908 22.5596H29.5908ZM30.6332 24.3394L34.7892 26.8394L36.3356 24.2687L32.1796 21.7686L30.6332 24.3394ZM34.8564 26.8775C35.7793 27.3698 37.0459 27.1627 37.6977 26.1928L35.2077 24.5195C35.3576 24.2964 35.5644 24.1912 35.7289 24.1547C35.8942 24.118 36.0861 24.1333 36.2684 24.2306L34.8564 26.8775ZM37.6955 26.1961C38.4281 25.112 37.949 23.779 36.9329 23.2401L35.5271 25.8903C35.3369 25.7894 35.1581 25.5966 35.0819 25.3255C35.0041 25.0489 35.0523 24.7494 35.2099 24.5163L37.6955 26.1961ZM37.0086 23.2831L33.1682 20.9509L31.611 23.5151L35.4514 25.8473L37.0086 23.2831ZM33.8896 22.233V16.2133H30.8896V22.233H33.8896ZM33.8896 16.2133C33.8896 14.9045 32.7554 14.1364 31.7402 14.1364V17.1364C31.4419 17.1364 30.8896 16.8851 30.8896 16.2133H33.8896ZM31.7402 14.1364C30.725 14.1364 29.5908 14.9045 29.5908 16.2133H32.5908C32.5908 16.8851 32.0385 17.1364 31.7402 17.1364V14.1364Z",
    fill: "#50595F",
    mask: "url(#path-2-inside-1_1_109)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1_109)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 66,
    r: 9.5,
    fill: "white",
    stroke: "url(#paint0_linear_1_109)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6642 66.6255L31.6525 66.6185L31.6404 66.6121C31.6156 66.599 31.6026 66.5843 31.5967 66.575C31.591 66.566 31.5908 66.561 31.5908 66.5596V60.2133C31.5908 60.2133 31.5908 60.2133 31.5908 60.2133C31.5908 60.2123 31.5904 60.1994 31.6132 60.1792C31.6373 60.1578 31.6808 60.1364 31.7402 60.1364C31.7996 60.1364 31.8431 60.1578 31.8672 60.1792C31.89 60.1994 31.8896 60.2123 31.8896 60.2133C31.8896 60.2133 31.8896 60.2133 31.8896 60.2133V66.233V66.5144L32.1301 66.6604L35.9704 68.9925L35.9829 69.0001L35.9957 69.0069C36.0349 69.0277 36.0431 69.0498 36.0446 69.0549C36.0455 69.0583 36.0454 69.0604 36.0452 69.0618C36.045 69.0629 36.0442 69.0676 36.0384 69.0762L36.0377 69.0773C36.0264 69.0941 35.9982 69.1193 35.9455 69.131C35.8964 69.1419 35.846 69.1359 35.8056 69.1168L31.6642 66.6255Z",
    fill: "white",
    stroke: "url(#paint1_linear_1_109)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 88,
    width: 64,
    height: 44,
    fill: "#3C82F6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 110,
    r: 10,
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.0908 104.213V110.56C31.0908 110.762 31.2103 110.95 31.4064 111.054L35.5624 113.554C35.8696 113.718 36.2689 113.63 36.4527 113.356C36.6371 113.083 36.5378 112.728 36.23 112.565L32.3896 110.233V104.213C32.3896 103.895 32.0987 103.636 31.7402 103.636C31.3817 103.636 31.0908 103.895 31.0908 104.213Z",
    fill: "url(#paint2_linear_1_109)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1_109",
    x: 18,
    y: 54,
    width: 28,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.443137 0 0 0 0 0.223529 0 0 0 0 0.729412 0 0 0 0.22 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1_109"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1_109",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_109",
    x1: 32,
    y1: 56,
    x2: 32,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_109",
    x1: 33.8181,
    y1: 56.5,
    x2: 33.8181,
    y2: 75.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1_109",
    x1: 33.8181,
    y1: 103.636,
    x2: 33.8181,
    y2: 113.636,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#3C82F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3C82F6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.476811fc2be307ec6131f14e3a825245.svg";
export { ForwardRef as ReactComponent };